import { Box, Grid, IconButton, Typography } from '@mui/material';
import _ from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
/** TRANSLATION*/
import { useTranslation } from 'react-i18next';

/** STYLE */
import { ButtonAddRecommend } from 'features/setting/treatments/diagnosis/style';

/** API */
import RecommendApi from 'api/setting/treatments/recommend.api';

/** UTILS || SLICE */
import { icons } from 'constants/images';

/** COMPONENT */
import DiagnosisTypeApi from 'api/setting/treatments/diagnosis-type.api';
import DiagnosisApi from 'api/setting/treatments/diagnosis.api';
import { setDisabledBtn } from 'app/slice/button.slice';
import { appendElement } from 'app/slice/form.slice';
import { addOptions, resetSelected, setSelected } from 'app/slice/select.slice';
import HeaderLabel from 'component/CardCustom/HeaderLabel';
import AutocompleteSelect from 'component/Select/AutocompleteSelect';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import SelectRecommends from 'features/setting/treatments/diagnosis/select-recommends';
import SelectInput from 'new-components/inputs/select-input';
import TextAreaInput from 'new-components/inputs/text-area-input';
import TextInput from 'new-components/inputs/text-input';
import { useParams } from 'react-router';
import { routeName } from 'routes/routes-name';

const initStateErrorMessage = {
  DIAGNOSIS_TYPE_NAME: ``,
  DIAGNOSIS_CODE: ``,
  IS_DUPLICATE_DIAGNOSIS_CODE: ``,
  DIAGNOSIS_CODE_STRING_BASE: ``,
  DIAGNOSIS_CODE_STRING_EMPTY: ``,
  DIAGNOSIS_CODE_MAXIMUM_LENGTH: ``,
  DIAGNOSIS_CODE_ANY_REQUIRED: ``,
  DIAGNOSIS_NAME: ``,
  IS_DUPLICATE_DIAGNOSIS_NAME: ``,
  DIAGNOSIS_NAME_STRING_BASE: ``,
  DIAGNOSIS_NAME_STRING_EMPTY: ``,
  DIAGNOSIS_NAME_MAXIMUM_LENGTH: ``,
  DIAGNOSIS_NAME_ANY_REQUIRED: ``,
  DIAGNOSIS_RECOMMENDS: ``
}

export default function FormDiagnosis() {
  const { t } = useTranslation()
  const history = useHistory()
  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  const [diagnosisTypeId, setDiagnosisTypeId] = useState(Number)
  const [diagnosisCode, setDiagnosisCode] = useState('')
  const [diagnosisName, setDiagnosisName] = useState('')
  const [diagnosisStatus, setDiagnosisStatus] = useState('ACTIVE')

  const [diagnosisTypes, setDiagnosisTypes] = useState([])

  /** Recommends */
  const tempRecommends: any = []
  const [countRecommends, setCountRecommends] = useState(0)

  const selectedValue = useSelector((state: any) => state.select.value)

  const renderRecommends = useSelector((state: any) => state.forms.render)
  const [checkRecommends, setCheckRecommends] = useState(false)
  const [recommends, setRecommends] = useState([]);
  const [recommendSelected, setRecommendSelected]: any = useState([]);
  const [disabledBtnAdd, setDisabledBtnAdd] = useState(false);
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const { id }: any = useParams()
  const dispatch = useDispatch()

  const loadData = useCallback(async () => {
    const res = await RecommendApi.findAll({ pageLimit: 50, status: 'ACTIVE', useWith: 'ALL' })

    if (res.status === 200) {
      const newRecommends: any = []
      _.map(res.data, (nr, index) => {
        newRecommends.push({ label: nr.recommendText, value: nr.recommendId })
      })
      setRecommends(newRecommends)

    }

    const respDiagnosisTypes = await DiagnosisTypeApi.findAll({ pageLimit: 50, status: 'ACTIVE' })
    if (respDiagnosisTypes.status === 200) setDiagnosisTypes(respDiagnosisTypes.data)

    if (id !== undefined) {
      const { status, data }: any = await DiagnosisApi.findById(id)
      if (status === 200) {
        setDiagnosisCode(data.diagnosisCode)
        setDiagnosisName(data.diagnosisName)
        setDiagnosisTypeId(data.diagnosisTypeId)
        setDiagnosisStatus(data.status)

        if (!_.isEmpty(data.diagnosisRecommends)) {
          const newRecommends: any = []
          _.map(data.diagnosisRecommends, (d, index) => {
            return newRecommends.push({ label: d.recommendText, value: d.recommendId })
          })
          setRecommendSelected(newRecommends)

        } else setRecommendSelected([])
      }
    }
  }, [])

  useEffect(() => {
    loadData()
  }, [loadData])

  const submit = () => {
    setDisabledSubmit(true)
    if (!diagnosisTypeId || !diagnosisCode || !diagnosisName) {
      setDisabledSubmit(false)
      return setErrorMessage({
        ...errorMessage,
        DIAGNOSIS_TYPE_NAME: !diagnosisTypeId ? t('DIAGNOSIS.MESSAGE.DIAGNOSIS_TYPE_NAME') : '',
        DIAGNOSIS_CODE: !diagnosisCode ? t('DIAGNOSIS.MESSAGE.DIAGNOSIS_CODE') : '',
        DIAGNOSIS_NAME: !diagnosisName ? t('DIAGNOSIS.MESSAGE.DIAGNOSIS_NAME') : ''
      })
    }

    const newRecommends: any[] = []
    recommendSelected.forEach((val: any) => {
      if (val) newRecommends.push({ recommendId: val.value })
    })
    const recommends = recommendSelected?.some((item: any) => !item?.value)
    if (recommends) {
      setDisabledSubmit(false)
      setCheckRecommends(true)
      return setErrorMessage({ ...errorMessage, DIAGNOSIS_RECOMMENDS: 'กรุณาเลือก คำแนะนำ' })
    }


    DiagnosisApi.create({ diagnosisTypeId, diagnosisCode, diagnosisName, diagnosisRecommends: newRecommends })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('DIAGNOSIS.MESSAGE.SUCCESS.CREATE'))
          resetForm()
          loadData()
          history.push(routeName.diagnosis)
        }
        else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`DIAGNOSIS.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`DIAGNOSIS.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!diagnosisTypeId || !diagnosisCode || !diagnosisName) {
      setDisabledSubmit(false)
      return setErrorMessage({
        ...errorMessage,
        DIAGNOSIS_TYPE_NAME: !diagnosisTypeId ? t('DIAGNOSIS.MESSAGE.DIAGNOSIS_TYPE_NAME') : '',
        DIAGNOSIS_CODE: !diagnosisCode ? t('DIAGNOSIS.MESSAGE.DIAGNOSIS_CODE') : '',
        DIAGNOSIS_NAME: !diagnosisName ? t('DIAGNOSIS.MESSAGE.DIAGNOSIS_NAME') : ''
      })
    }

    const newRecommends: any[] = []
    recommendSelected.forEach((val: any) => {
      if (val) newRecommends.push({ recommendId: val.value })
    })
    const recommends = recommendSelected?.some((item: any) => !item?.value)
    if (recommends) {
      setDisabledSubmit(false)
      setCheckRecommends(true)
      return setErrorMessage({ ...errorMessage, DIAGNOSIS_RECOMMENDS: 'กรุณาเลือก คำแนะนำ' })
    }

    DiagnosisApi.update(id, { diagnosisTypeId, diagnosisCode, diagnosisName, diagnosisRecommends: newRecommends, status: diagnosisStatus })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`DIAGNOSIS.MESSAGE.SUCCESS.UPDATE`))
          resetForm()
          loadData()
          history.push(routeName.diagnosis)
        }
        else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`DIAGNOSIS.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`DIAGNOSIS.MESSAGE.${err.message}`) } })
      })
  }

  useEffect(() => {
    if (_.some(recommendSelected, (selected) => selected.value === '' || selected.value === 0)) setDisabledBtnAdd(true)
    else setDisabledBtnAdd(false)
  }, [recommendSelected]);

  const addRecommend = () => {
    setRecommendSelected([...recommendSelected, { label: '', value: 0 }])

    const newOptions: any[] = []
    const newValue: any = []

    _.map(selectedValue, (val: any, iValue: number) => {
      if (val !== null) newValue[iValue] = val
    })

    dispatch(resetSelected(newValue))
    _.map(tempRecommends, (recommend: any, index: number) => {
      if (newValue.indexOf(recommend.value) === -1) newOptions.push(recommend)
    })

    if (renderRecommends !== undefined && newValue[countRecommends - 1] === null) return notiError(t('RECOMMEND.INPUT.PLEASE_RECOMMEND'))

    const count = countRecommends
    dispatch(setSelected({ key: [count], value: null }))
    dispatch(addOptions({ key: [count], value: newOptions }))
    dispatch(
      appendElement({
        index: count,
        value: (
          <SelectRecommends
            key={`key-recommends-${count}`}
            index={Number(count)}
            setSearch={(value) => {
              return
            }}
            removeRecommend={removeRecommend}
          />
        )
      })
    )

    dispatch(setDisabledBtn(true))
    setCountRecommends((pre) => pre + 1)
  }

  function removeRecommend(no: number) {
    const items = _.filter(recommendSelected, (i, index: number) => index !== no)
    setRecommendSelected(items)

  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setDiagnosisTypeId(0)
    setDiagnosisCode('')
    setDiagnosisName('')
    clearErrorMessage()
  }

  return (
    <Box>
      <HeaderLabel
        text={id ? t('DIAGNOSIS.TITLE_UPDATE') : t('DIAGNOSIS.TITLE_CREATE')}
        navigator={{ previousTo: routeName.diagnosis, previousTitle: t('DIAGNOSIS.TITLE'), currentTitle: id ? t('DIAGNOSIS.TITLE_UPDATE') : t('DIAGNOSIS.TITLE_CREATE') }}
        goBack={routeName.diagnosis}
        onSubmit={id ? submitEdit : submit}
        disabled={disabledSubmit}
      />
      <Box padding="24px">
        <Box boxShadow={3} width="100%" paddingX="32px" paddingY="24px">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>{t('TREATMENTS.FOOTER_TAB.DIAGNOSIS')}</Typography>
            </Grid>
            <Grid item sm={12} md={6}>
              <SelectInput
                onChange={(event) => {
                  const value = event.target.value
                  if (value) {
                    setDiagnosisTypeId(value)
                    clearErrorMessage()
                  }
                }}
                label={t('DIAGNOSIS.INPUT.DIAGNOSIS_TYPE')}
                options={diagnosisTypes.map((diagnosisType: any) => {
                  return { value: diagnosisType.diagnosisTypeId, name: diagnosisType.diagnosisTypeName }
                })}
                value={diagnosisTypeId ? diagnosisTypeId : ''}
                width="100%"
                helperText={errorMessage.DIAGNOSIS_TYPE_NAME || ''}
                required
              />
            </Grid>
            <Grid item sm={12} md={6}>
              <TextInput
                onChange={(event) => {
                  setDiagnosisCode(event.target.value)
                  clearErrorMessage()
                }}
                value={diagnosisCode}
                helperText={
                  errorMessage.DIAGNOSIS_CODE ||
                  errorMessage.IS_DUPLICATE_DIAGNOSIS_CODE ||
                  errorMessage.DIAGNOSIS_CODE_STRING_BASE ||
                  errorMessage.DIAGNOSIS_CODE_STRING_EMPTY ||
                  errorMessage.DIAGNOSIS_CODE_MAXIMUM_LENGTH ||
                  errorMessage.DIAGNOSIS_CODE_ANY_REQUIRED
                }
                label={t('DIAGNOSIS.INPUT.DIAGNOSIS_CODE')}
                required
                fullWidth
              />
            </Grid>
            <Grid item sm={12} md={6}>
              <TextAreaInput
                onChange={(event) => {
                  setDiagnosisName(event.target.value)
                  clearErrorMessage()
                }}
                value={diagnosisName}
                helperText={
                  errorMessage.DIAGNOSIS_NAME ||
                  errorMessage.IS_DUPLICATE_DIAGNOSIS_NAME ||
                  errorMessage.DIAGNOSIS_NAME_STRING_BASE ||
                  errorMessage.DIAGNOSIS_NAME_STRING_EMPTY ||
                  errorMessage.DIAGNOSIS_NAME_MAXIMUM_LENGTH ||
                  errorMessage.DIAGNOSIS_NAME_ANY_REQUIRED
                }
                label={t('DIAGNOSIS.INPUT.DIAGNOSIS_NAME')}
                fullWidth
                rows={3}
                required
                marginBottomErrorText='8px'
              />
            </Grid>
            <Grid item sm={12} md={6}></Grid>
            <Grid item xs={12} paddingY="16px">
              <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>{t('RECOMMEND.INPUT.RECOMMEND_TEXT')}</Typography>
            </Grid>
            <Grid item xs={12} paddingY="16px">
              <ButtonAddRecommend variant="text" disabled={disabledBtnAdd} onClick={() => addRecommend()} className="d-flex" sx={{ marginBottom: '1px' }}>
                <span className={'mr-1'}>+</span> {t('RECOMMEND.TITLE_CREATE')}
              </ButtonAddRecommend>
            </Grid>
          </Grid>
          {_.map(recommendSelected, (r: any, index: number) => {
            return (
              <Grid item xs={12}>
                <Box display="flex" flexDirection="row" alignItems="center" width="100%" gap="24px" marginBottom="16px">
                  <Typography textAlign="right" sx={{ width: '4%' }}>{index + 1}</Typography>
                  <Box sx={{ width: { lg: '70% !important', xl: '60% !important' } }}>
                    <AutocompleteSelect
                      key={r.recommendId}
                      labelId={r.recommendId}
                      options={
                        _.map(recommends, (rec: any) => {
                          return { label: rec.label, value: rec.value }
                        })
                      }

                      renderOption={(props, option: any) => (
                        <Box
                          {...props}
                          key={option.value}
                          component="li"
                          sx={{
                            pointerEvents: _.some(recommendSelected, { value: option?.value }) ? 'none !important' : 'auto !important',
                            opacity: _.some(recommendSelected, { value: option?.value }) ? .5 : 1
                          }}>
                          {option.label}
                        </Box>
                      )}
                      noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                      onchange={(event, value: any) => {
                        if (value) {
                          clearErrorMessage()
                          const items: any = _.merge([], recommendSelected)
                          items[index].label = value.label
                          items[index].value = value.value
                          setRecommendSelected(items)

                        }
                      }}
                      getOptionLabel={(option: any) => option.label}
                      onInputChange={(event: any, newValue: any) => {
                        return
                      }}
                      value={r || recommends.find((v: any) => v.value === r.recommendId)}
                      isOptionEqualToValue={(option: any, value: any) => option.value === r.value}
                      errMessage={checkRecommends && !r.value || 0 ? errorMessage.DIAGNOSIS_RECOMMENDS : ''}
                      disableClearable
                    />
                  </Box>
                  <IconButton disableFocusRipple disableRipple onClick={() => {
                    clearErrorMessage()
                    removeRecommend(index)
                  }} className="p-0" sx={{ backgroundColor: 'transparent' }}>
                    <img src={icons.btnTrash} alt="discard" />
                  </IconButton>
                </Box>
              </Grid>
            )
          })}
        </Box>
      </Box>
    </Box >
  )
}
